import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from 'protractor';
import * as auth from 'src/app/auth';
import { ErrorService } from '../services/error.service';
import { ReferenceDataService } from '../services/reference-data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  isSignInDisabled = false;
  isSignOutDisabled = false;

  constructor(
    private errorService: ErrorService,
    private router: Router,
    private referenceDataService: ReferenceDataService ) { }

  ngOnInit(): void {
    this.login();
  }

  async login(): Promise<void> {
    try {
      this.isSignInDisabled = true;
      await auth.acquireToken();
      this.referenceDataService.get();
      this.goToReturnUrl();
    }
    catch (error) {
      this.isSignInDisabled = false;
      this.errorService.show('Login failed', error)
    }
  }

  get isAuthenticated(): boolean {
    return auth.isAuthenticated;
  }

  goToReturnUrl() : void {
    const returnUrl = sessionStorage.getItem('returnUrl') || '/';
    sessionStorage.removeItem('returnUrl');
    sessionStorage.removeItem('visited_channels');
    sessionStorage.removeItem('analytics_general');
    this.router.navigateByUrl(returnUrl);
  }

  signIn(): void {
    this.isSignInDisabled = false;
    this.login();
  }

  async signOut(): Promise<void> {
    this.isSignOutDisabled = true;
    await auth.signOut();
    this.isSignOutDisabled = false;
  }
}
